import { CaseDiagnosis } from "pwapi";

import { SlideDetailState } from "reducers/slideDetailReducer";

import { CaseDetailState } from "../reducers/caseDetailReducer";

export const useCurrentSpecimenDiagnoses = (
  caseDetailObject: CaseDetailState,
  slideDetailObject: SlideDetailState
) => {
  return caseDetailObject.specimenDetail.find(
    (spec) => slideDetailObject.specimen?.id === spec.id
  )?.diagnoses;
};

export const useSentDiagnosis = (
  caseDetailObject: CaseDetailState,
  currentSlideId?: number
) => {
  // Note that this is not actually a hook which is why it works wwith SlideButtons.whichDiagnosisDialog()
  // TODO: Select these directly from state instead of passing case detail state as an argument
  const slide = caseDetailObject.slides.find((s) => s.id === currentSlideId);
  const block = caseDetailObject.blocks?.find(
    (b) => b.id === slide?.block_obj_id
  );
  const specimen = caseDetailObject.specimens?.find(
    (s) => s.id === block?.specimen_id
  );

  // TODO: the below is clearly un-ergonomic
  const currentDiagnoses = caseDetailObject.specimenDetail.filter(
    (s) => s.id === specimen?.id
  )[0]?.diagnoses;
  const sentDiagnosis =
    currentDiagnoses &&
    currentDiagnoses.length &&
    currentDiagnoses[0].source !== CaseDiagnosis.source.SCREEN
      ? currentDiagnoses[0]
      : undefined;

  return sentDiagnosis;
};

export const useLISFinalizedDiagnosis = (caseDetailObject: CaseDetailState) => {
  // NOTE: .find because there should only be one?
  // this might change in the future with AMEND and ADDEND
  return caseDetailObject.case_diagnosis?.find(
    (d) => d.source === CaseDiagnosis.source.LIS_FINALIZED
  );
};

export default useSentDiagnosis;
